<template>
  <div class="app-container">
    <div>
      <p>{{ $t("common.download_template_excel") }}</p>
      <i class="fa fa-download" aria-hidden="true"></i>
      <a @click="exportExcelFile">{{$t('common.exportFileExcel')}}</a>
    </div>
    <upload-excel-component
      :on-success="handleSuccess"
      :before-upload="beforeUpload"
    />
    <b-table
      striped
      hover
      small
      :items="resultImportList"
      :fields="resultImportList_fields"
      class="mt-3"
      outlined
    >
      <template #head()="scope">
        <div>{{ $t(scope.label) }}</div>
      </template>
      <template slot="statusImport" slot-scope="row">
        <!-- {{row}} -->
        <p style="color:green" v-if="row.item.statusImport == 'PASS'">
          {{ row.item.statusImport }}
        </p>
        <p style="color:red" v-else>{{ row.item.statusImport }}</p>
        <p />
      </template>
    </b-table>

    <div class="box-footer">
      <button
        id="cmdCancel"
        type="button"
        class="btn btn-default"
        @click="CancelList"
        style="margin-right: 5px;"
      >
        {{ $t("common.close") }}
      </button>
    </div>
    <lte-core-alert
      v-for="snackbar in GET_SNACK_BAR"
      :key="snackbar.id"
      :item="snackbar"
    ></lte-core-alert>
  </div>
</template>

<script>
import UploadExcelComponent from "@/components/UploadExcel/index.vue";
import LTECoreAlert from "@/components/LTESnackBar.vue";
import utils from "@/lib/utils";

import { mapGetters, mapActions } from "vuex";
import XLSX from "xlsx";
export default {
  name: "ApartmentImportExcel",
  components: {
    UploadExcelComponent,
    "lte-core-alert": LTECoreAlert
  },
  data() {
    return {
      tableData: [],
      tableHeader: [],
      hdBackground: "background-color: #4b646f;border:1px solid white;", //00a65a

      resultImportList: [], // Result import
      resultImportList_fields: [
        {
          key: "apartment_code",
          label: "apartment.apartment_code",
          sortable: true,
          class: "text-center"
        },
        {
          key: "statusImport",
          label: "common.status",
          sortable: true,
          class: "text-center"
        },
        {
          key: "errorDetail",
          label: "common.error",
          sortable: true,
          class: "text-center"
        }
      ],

      validateElement: {},
      invoiceType: null,
      headerRequired: [
        "Mã Căn", "Kỳ kế toán", "Số tiền", "Ngày thu (Định dạng dd/mm/yyyy)"
      ]
    };
  },
  watch: {},
  computed: {
    ...mapGetters([
      "GET_SNACK_BAR"
    ])
  },
  methods: {
    ...mapActions([
      "ON_SHOW_TOAST",
      "IMPORT_RECEIPT_FROM_EXCEL_FILE"
    ]),
    beforeUpload(file) {
      const isLt1M = file.size / 1024 / 1024 < 1;

      if (isLt1M) {
        return true;
      }

      this.$message({
        message: "Please do not upload files larger than 1m in size.",
        type: "warning"
      });
      return false;
    },
    CancelList: function() {
      this.$router.push({
        name: "ReceiptList"
      });
    },
    exportExcelFile: function() {
      let data_list = []
      let json_data = {
        "Mã Căn": "0501",
        "Kỳ kế toán": "202103",
        "Số tiền": "1579573",
        "Dư nợ": "",
        "Ngày thu (Định dạng dd/mm/yyyy)": "10/04/2021",
        "Diễn giải": "Thanh toán điện nước T03/2021 và công nợ PQL Quý II/2021"
      };

      data_list.push(json_data)
      // export json to Worksheet of Excel
      // only array possible
      var ReceiptFile = XLSX.utils.json_to_sheet(data_list);
      // var pokemonWS = XLSX.utils.json_to_sheet(this.Datas.pokemons)

      // A workbook is the name given to an Excel file
      var wb = XLSX.utils.book_new(); // make Workbook of Excel

      // add Worksheet to Workbook
      // Workbook contains one or more worksheets
      XLSX.utils.book_append_sheet(wb, ReceiptFile, "ReceiptFile"); // sheetAName is name of Worksheet
      // XLSX.utils.book_append_sheet(wb, pokemonWS, 'pokemons')

      // export Excel file
      XLSX.writeFile(wb, "ReceiptFile.xlsx"); // name of the file is 'book.xlsx'
    },
    checkHeaderInExcelFile: function (headerInExcelFile) {
      let results = "OK"
      // let headerRequired = [
      //   "Mã Căn", "Kỳ kế toán", "Số tiền", "Ngày thu (Định dạng dd/mm/yyyy)"
      // ]
      let headerRequired = [...this.headerRequired]
      let headerValidateArray = []
      for (let i=0, size=headerInExcelFile.length; i<size; i++){
        if (headerRequired.includes(headerInExcelFile[i].trim())){
          headerValidateArray.push(headerInExcelFile[i].trim())
        }
      }
      let arrayResult = headerRequired.filter(x => !headerValidateArray.includes(x));
      // for (let i=0, size=headerRequired.length; i < size; i++ ){
      //   if (headerInExcelFile.includes(headerRequired[i])===false) {
      //     results = this.$t('invoice.importExcel.notiNotFoundHeader', {'0': headerRequired[i]}) 
      //     break
      //   }
      // }
      if (arrayResult.length > 0) {
        results = this.$t('invoice.importExcel.notiNotFoundHeader', {'0': arrayResult[0]}) 
      }
      return results
    },
    showError: function(msg) {
      this.ON_SHOW_TOAST({
        message: this.$t(msg),
        styleType: "danger"
      });
    },
    handleSuccess({ results, header }) {
      let validateFile = this.checkHeaderInExcelFile(header)
      if (validateFile==="OK") {
        this.tableData = results;
        let data = {
          headers: header,
          dataImport: results,
          invoiceTypeImport: this.invoiceType
        };
        // init empty
        this.resultImportList = [];
        this.IMPORT_RECEIPT_FROM_EXCEL_FILE(data)
          .then(
            function(res) {
              //{"status":"success","dataResult":[{"username":"user11595909","result":"PASS","error":"","type":"UPDATE"}]}

              res.dataResult.forEach(v => {
                let dataPass = {
                  apartment_code: v.apartment_code,
                  statusImport: v.result,
                  errorDetail: v.error
                };
                this.resultImportList.push(dataPass);
              });
            }.bind(this)
          )
          .catch(
            function() {
              let dataError = {
                apartment_code: "Unknown",
                statusImport: "FAIL",
                errorDetail: "Unknown"
              };

              this.resultImportList.push(dataError);
            }.bind(this)
          );

        this.tableHeader = header;
      } else {
        this.showError(validateFile)
      }
    }
  },
  mounted() {
    let invoiceType = this.$route.query.invoiceType
    if (!utils.isEmptyString(invoiceType)) {
      this.invoiceType = JSON.parse(invoiceType)
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/Receipt/ReceiptImportExcel.vue